import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ChartType } from 'app/modules/domain/enums/ChartType';
import BranchConstants from 'app/modules/shared/constants/branch-constant';
import { BaseChartDirective } from 'ng2-charts';

@Component({
  selector: 'app-branch-info',
  templateUrl: './branch-info.component.html',
  styleUrls: ['./branch-info.component.scss']
})
export class BranchInfoComponent implements OnInit {
  public ChartTypes1 = BranchConstants.chartTypes1;
  public ChartTypes2 = BranchConstants.chartTypes2;

  public selectedChart1 = ChartType.Pie;
  public selectedChart2 = ChartType.Line;
  public ChartOneTitle = BranchConstants.chartOneTitle;
  public aggregate = true;
  public showPercentages = true;

  @Input() Route_Information: any[];
  @Input() chart: any;
  @Input() summaryChart: any;
  @Input() checkPeakAndLow: any;
  @Input() pieChartDataByPercent: any;
  @Input() pieChartLabels: any;
  @Input() colors: any;
  @Input() options: any;
  @Input() legend: any;
  @Input() ChartType: any;
  @Input() checkIfDataExist: any;

  @Output() Chartchanged: EventEmitter<any> = new EventEmitter();
  @Output() aggregateData: EventEmitter<any> = new EventEmitter();
  @Output() showPercent: EventEmitter<any> = new EventEmitter();
  @Output() comparisonClicked: EventEmitter<any> = new EventEmitter();
  @Output() pieStackedChanged: EventEmitter<any> = new EventEmitter();
  @Output() pieClicked: EventEmitter<any> = new EventEmitter();
  @ViewChild(BaseChartDirective)
  public piechart: BaseChartDirective;

  public pieChartLabel: string[] = [];
  public pieChartData: number[] = [];
  public pieChartType: any = this.selectedChart1;
  public color: any = [];
  public option: any;
  public legend1: any;
  constructor() { }
  // tslint:disable-next-line:use-life-cycle-interface
  ngOnChanges(changes: SimpleChanges): void {
    // tslint:disable-next-line:curly
    if (this.piechart !== undefined)
      this.piechart.chart.config.data.labels = this.pieChartLabels;
    this.pieChartLabel = this.pieChartLabels;
    this.pieChartData = this.pieChartDataByPercent;
    this.pieChartType = this.ChartType;
    this.color = this.colors;
    this.option = this.options;
    this.legend1 = this.legend;
  }
  ngOnInit() { }
  toggleChart() {
    this.Chartchanged.emit(this.selectedChart2);
  }
  aggregateByHour() {
    this.aggregateData.emit(this.aggregate);
  }
  showPercentage() {
    this.showPercent.emit(this.showPercentages);
  }
  summaryClicked(e) {
    let activePoint = this.summaryChart.getElementAtEvent(e)[0];
    this.comparisonClicked.emit(activePoint);
  }
  toggleSummaryChart() {
    this.pieStackedChanged.emit(this.selectedChart1);
  }
  chartSectionClicked(e) {
    this.pieClicked.emit(e);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/route-detail/components/branching-container/components/branch-info/branch-info.component.ts